import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';

// Find the root element where the React app will be mounted
const container = document.getElementById('autocomplete-search-root');

// Ensure the container element exists before attempting to render
if (container) {
  // Create a root for rendering. This is the recommended way for React 18+.
  const root = ReactDOM.createRoot(container);

  // Render the MainApp component into the root
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element with ID "root" not found. React app cannot be mounted.');
}